<!-- 免责声明 -->
<template>
  <div class="content">
    <AppNavbar
      v-if="isApp"
      :options="options"
      :placeholder="true"
      :zIndex="999"
      title="免责声明"
    >
    </AppNavbar>
    <div class="box"
      >让您的营养师更多的了解到您的饮食变化会是更利于您的选择。如果你有健康问题或者服用任何两种及以上药物可能会受到饮食变化的影响，请先咨询你的医疗服务提供者。
      <br />Please remember that it’s always a good idea to keep your physician
      or healthcare specialist up-to-date on changes you make to your diet. If
      you have a medical condition and/or take any 2 medications that may be
      affected by dietary changes, please consult with your medical provider
      first.
    </div>
  </div>
</template>
<script>
import AppNavbar from '@/components/app/nav-bar/index.vue'
export default {
  components: {
    AppNavbar
  },
  data() {
    return {
      isApp: false,
      options: {
        barBackgroundColor: '#ffffff',
        color: 'rgba(0,0,0,0.8)'
      }
    }
  },
  created() {
    this.isApp = this.$betterwe.isApp()
  },
  methods: {}
}
</script>
<style lang="scss" scoped>
.content {
  background: #f9f9f9;
  min-height: 100vh;
  padding: 20px;

  .box {
    padding: 20px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    color: rgba(0, 0, 0, 0.5);
    line-height: 29px;
    background: #ffffff;
    border-radius: 12px;
  }
}
</style>
